module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"aiInterview":"Вопросы от ИИ","aiInterviewDescription":"Искусственный Интеллект сам подберет и озвучит вопросы для вашей вакансии. Вы сможете внести изменения, при необходимости.","recommended":"Рекомендовано","selectionQOver":"Подбор вопросов окончен"}}')
  delete Component.options._Ctor
}
